<mat-card>
  <mat-card-content>
    <h4>You have a new {{notice.notificationType}} in your inbox</h4>
  </mat-card-content>
  <mat-card-actions>
    <button mat-button (click)="readNow()">Read Now</button>
    <button mat-button (click)="readLater()">Read Later</button>
  </mat-card-actions>
</mat-card>
<audio src="assets/sounds/got-it-done-613.mp3" autoplay></audio>